import {FUIAbstractInput} from "../../framework/abstract-input";
import {ChangeDetectorRef, Directive, HostListener, Input} from "@angular/core";

@Directive()
export abstract class FUIAbstractRadioInput extends FUIAbstractInput {
    @Input() public equivalent: string;

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    /**
     * Radio inputs require a click action to be performed no matter where they
     * are clicked, instead of a focus action that is used on other input types
     */
    @HostListener("click")
    public override click(): void {
        this.input.nativeElement.click();
    }

    /**
     * Generate an identifier for the radio button to
     * differentiate it within the group
     */
    id(): string {
        return this.name + encodeURI(this.equivalent);
    }

    /**
     *
     * @returns {any}
     */
    override get value(): any {
        return super.value;
    }

    /**
     * Overriding implementation of the valuer setter.
     * Difference here is the way the valued boolean is dealt with,
     * it isn't set to true simply for having a value; the value
     * must be equal to the equivalent provided.
     * @param value
     */
    @Input()
    override set value(value: any) {
        if (value !== this._value) {
            if (value === undefined) {
                value = null;
            }
            this._value = value;
            this.onChange(value);
            this.valueChange.emit(value);
        }
        this.valued = this._value == this.equivalent;
    }

    /**
     * Override for writevalue to also write
     * the initial and subsequent valued states
     * @param value
     */
    override writeValue(value: any): void {
        this._value = value;
        this.valued = this._value == this.equivalent;
        this.changeDetectorRef.detectChanges();
    }
}
